import VariantModel from 'coreClasses/product/VariantModel';
import {EEventSource, IEventData} from 'coreClasses/events/IEvents';
import {IAnalyticsEvent} from 'coreClasses/analytics/IAnalytics';

import {EAnalyticsEventSource, EAnalyticsEventType} from 'brandClasses/analytics/EAnalyticsEvent';

import ProductItemEvent from './common/ProductItemEvent';

/**
 * Represents SelectItemEvent
 */
export default class SelectItemEvent implements IAnalyticsEvent {
	public event: string;
	public event_trigger: string;
	public ecommerce: any;

	/**
	 * @constructor
	 * @param {IEventData} data - data
	 */
	constructor(data: IEventData) {
		const {productData, sourceSpecification, plp_category_id, plp_category_name} = data;
		const eventSourceCategoryId: string = data.eventSourceCategoryId || productData.eventSourceCategoryId;
		const eventSourceCategoryName: string = data.eventSourceCategoryName || productData.eventSourceCategoryName || sourceSpecification;
		const product: VariantModel = productData?.product;
		const position = productData?.position;
		const productCategoriesIds: string[] = productData?.productCategoriesIds;
		const source = EAnalyticsEventSource[EEventSource[data.source]];
		const productItem = new ProductItemEvent({
			source,
			product,
			eventSourceCategoryId,
			eventSourceCategoryName,
			productCategoriesIds,
			index: position,
		});

		this.event = EAnalyticsEventType.SELECT_ITEM;
		this.event_trigger = 'ecomm';
		this.ecommerce = {
			currency: product.getPriceCurrency(),
			plp_category_id,
			plp_category_name,
			item_list_id: source,
			items: [{...productItem}],
		};
	}
}
